

















import Vue from 'vue';
import UserInfo from '../../components/UserInfo.vue';

export default Vue.extend({
    components: {
        UserInfo,
    },
    data() {
        return {
            searchKeyword: '',
        };
    },
    methods: {
        search() {
            this.$router.push({
                path: '/search-results',
                query: {
                    keyword: this.searchKeyword as string,
                },
            });
            this.searchKeyword = '';
        },
    },
});
